export default {
	type: 'object',
	properties: {
		projectId: { type: 'string' },
	},
	required: ['projectId'],
	additionalProperties: false,
}
